import "./block-accordion.css";
import React, { useEffect, useRef, useState } from "react";
import ReactDOM from "react-dom";

const Search = () => {
  const [search, setSearch] = useState("");
  const accordion = useRef(document.querySelector(".block-accordion"));

  useEffect(() => {
    // filter the tabs based on data-title attribute
    const allTabs = accordion.current.querySelectorAll(".accordion");
    if (search) {
      Array.from(allTabs).forEach((tab) => {
        const match =
          tab.dataset.title?.toLowerCase().includes(search.toLowerCase()) ||
          tab.dataset.content?.toLowerCase().includes(search.toLowerCase());

        if (match) tab.classList.remove("hidden");
        else tab.classList.add("hidden");
      });
    } else {
      allTabs.forEach((tab) => tab.classList.remove("hidden"));
    }
  }, [search]);

  return (
    <input
      type="search"
      placeholder="Search"
      className="mb-4"
      onChange={(e) => setSearch(e.target.value)}
    />
  );
};

document.addEventListener("DOMContentLoaded", function () {
  ReactDOM.render(<Search />, document.querySelector("#search"));
});
